import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';

const signInWithEmail = async ({ email, password }) => {
    try {
        const userCredential = await firebase.auth().signInWithEmailAndPassword(email, password);
        if (userCredential) {
            const { email, uid, displayName } = userCredential.user;
            console.log(`User: ${email}, UID: ${uid}`);
            return { uid, displayName, email };
        }
    } catch (error) {
        const errorCode = error.code;
        const errorMessage = error.message;

        // Handling specific errors
        if (errorCode === 'auth/invalid-email') {
            alert('Error: The email address is not valid.');
        } else {
            console.error('Error creating user:', errorCode, errorMessage);
        }
        return null; // Return null in case of an error
    }
};

export { signInWithEmail };
